export default {
  isLoading: false,
  customers: [],
  stats: {},
  topCustomers: [],
  disputedCustomers: [],
  overdueCustomers: [],
  countOverdueCustomers: 0,
  percentageOverdueCustomers: 0,
  selected: [],
};
